export enum UserType {
  FieldManagers = 'field-manager',
  ProjectManager = 'project-manager',
  Contacts = 'whc-contact',
  Partners = 'partner',
}
